/**
 * The "Execution" menu. See lib/navigation/nav-manifest.js for the entry shape
 * and the vocabulary `requires` draws from.
 */

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const EXECUTION_ITEMS = [
  {
    href: "/dem-cog/reports",
    label: "Deal Clinic",
    iconName: "IoBarChartOutline",
    requires: "dealClinic",
  },
  {
    href: "/dashboard/conversation-analyzer",
    label: "Conversation Analyzer",
    iconName: "IoStatsChartOutline",
    requires: "conversationAnalysis",
  },
  {
    href: "/simulator/on-the-fly",
    label: "On-the-fly Plays",
    iconName: "LiaTheaterMasksSolid",
    requires: "onTheFly",
  },
  {
    href: "/workspaces/scripts",
    label: "Email & Talking Script Generator",
    iconName: "IoDocumentTextOutline",
    requires: "scriptGenerator",
  },
  {
    // Prep5 is an external service. Practice-only studios should not see the
    // Execution menu at all (SAL-2532), so only offer Prep5 once the studio has
    // at least one execution module enabled.
    href: "https://prep5.salesably.ai/dashboard",
    label: "Prep5 - AI Sales Preparation",
    iconName: "IoFlashOutline",
    external: true,
    requires: "anyExecutionModule",
  },
];
